<template>
    <div class="font-['Red_Hat_Display'] text-lg font-semibold p-5 bg-[#DEF4FC] rounded-2xl text-center text-[#3F4A55]">
        <p>You already voted!</p>
        <p class="text-sm">Watch for results below</p>
    </div>
</template>
